import { Component, inject } from '@angular/core';
import { RoadDistanceService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RoadDistanceCreateDto,
  RoadDistanceDto,
  RoadDistanceExcelDownloadDto,
  RoadDistanceUpdateDto,
} from '../proxy/controlling/dtos/road-distance';
import { ROADDISTANCE_CONFIG, ROADDISTANCE_FIELDS } from './road-distance.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-road-distance',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RoadDistanceService, ConfirmationService],
  templateUrl: './road-distance.html',
  styleUrl: './road-distance.scss',
})
export class RoadDistance extends BaseCrudComponent<
  RoadDistanceDto,
  RoadDistanceCreateDto,
  RoadDistanceUpdateDto,
  RoadDistanceExcelDownloadDto
> {
  service = inject(RoadDistanceService);
  config = ROADDISTANCE_CONFIG;
  fields = ROADDISTANCE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RoadDistanceDto): RoadDistanceUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RoadDistance';
  }
}
